module.exports = __webpack_public_path__ + "static/media/banner02.71c0cdef.jpg";